import type { TrackZone } from '../zones/TrackZoneTypes'

/** Which key-point markers a zone's detail map should show. */
export type ZoneMarkerKind = 'braking' | 'apex' | 'none'

/**
 * Keyed on zone TYPE alone — one-for-one with the header glyph chips
 * (mobile zoneGlyphItems), so map markers and chips can never disagree,
 * including after a lap exclusion recomputes the legacy variance fields
 * this function used to read (pass-9 spec RC5).
 */
export function getZoneMarkerKind(zone: TrackZone | null): ZoneMarkerKind {
  if (!zone) return 'none'
  if (zone.type === 'braking') return 'braking'
  if (zone.type === 'cornering') return 'apex'
  return 'none'
}
